<template>
  <b-container id="details-subview">
  </b-container>
</template>

<script>
export default {
  name: 'AccountDetails',
  data () {
    return {
    }
  },
  mounted: function () {
  },
  computed: {
  }
}
</script>

<style lang="scss">

</style>
